import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ChangePassword } from '../../models/change-password';
import { User, usernameAsString } from '../../models/user';
import { ErrorService } from '../../services/error.service';
import { SnackbarService } from '../../services/snackbar.service';
import { UserService } from '../../services/user.service';
import { WorkerService } from '../../services/worker.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
	selector: 'app-change-password-modal',
	templateUrl: './change-password-modal.html'
})
export class ChangePasswordModalComponent implements OnInit, OnDestroy {
	public form: UntypedFormGroup;
	public showCurrentPassword = false;
	public showNewPassword = false;
	public showVerifyPassword = false;
	public user = new User();
	public userPasswordChange = new ChangePassword();
	public userSubscription: any;

	constructor(private _userService: UserService,
				private _location: Location,
				private _vcRef: ViewContainerRef,
				private _errorService: ErrorService,
				private _workerService: WorkerService,
				public dialogRef: MatDialogRef<ChangePasswordModalComponent>,
				private _dialog: MatDialog,
				private _formBuilder: UntypedFormBuilder,
				private _snackbarService: SnackbarService) {
	}

	changePassword() {
		if (this.form.valid) {
			this.userPasswordChange.newPassword = this.form.get('newPassword').value;
			this.userPasswordChange.oldPassword = this.form.get('currentPassword').value;
			if (this.user.inetUser) {
				this.userPasswordChange.userName = usernameAsString(this.user);
				this._userService.changePassword(this.userPasswordChange).subscribe(
					() => {
						this.displaySuccessModal();
					},
					(error) => {
						error.error.generalMsg = 'Password Requirement Not Met';
						this._errorService.error(error, 'Change password Failed', 'modal');
					});
			} else {
				this.userPasswordChange.id = this.user.driverId.toString();
				this._workerService.changePassword(this.userPasswordChange).subscribe(
					() => {
						this.displaySuccessModal();
					},
					(error) => { 
						error.error.generalMsg = 'Password Requirement Not Met';
						this._errorService.error(error, 'Change password Failed', 'modal');
					});
			}
		} else {
			this._snackbarService.openSnackBar('Please fill out all required fields.', 'Close', 3000);
		}
	}

	close() {
		this.dialogRef.close();
	}

	displaySuccessModal() {
		const dialogRef = this._dialog.open(ModalComponent, {
			data: {
				title: 'Alert',
				message: 'You have successfully changed your password!',
				showCancel: false
			}
		});
		dialogRef.afterClosed().subscribe(() => {
			this._location.back();
		});
	}

	ngOnDestroy() {
		if (this.userSubscription) {
			this.userSubscription.unsubscribe();
		}
	}

	ngOnInit() {
		this.form = this._formBuilder.group({
			currentPassword: [null, [Validators.required]],
			newPassword: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(64)]],
			verifyPassword: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(64)]]
		});
		this.userSubscription = this._userService.user$.subscribe((data) => {
			this.user = data;
		});
	}

	toggleShowCurrentPassword() {
		this.showCurrentPassword = !this.showCurrentPassword;
	}

	toggleShowNewPassword() {
		this.showNewPassword = !this.showNewPassword;
	}

	toggleShowVerifyPassword() {
		this.showVerifyPassword = !this.showVerifyPassword;
	}
}
